import { Container } from '../components/layout/Primitives';

export default function Careers() {
  return (
    <div className="animate-fade-in">
      <Container style={{ padding: '3.5rem 1.5rem 4rem', maxWidth: '56rem' }}>
        <h1 className="font-display" style={{ margin: 0, fontSize: 'clamp(2rem,4vw,3.25rem)' }}>Careers</h1>
        <p style={{ marginTop: '1rem', opacity: 0.78, lineHeight: 1.75 }}>
          We are building a focused team across design, product, operations, and commerce. For opportunities, please
          reach out through our contact page with your CV and portfolio (if applicable).
        </p>
      </Container>
    </div>
  );
}
